// extracted by mini-css-extract-plugin
export var container = "attributionPeter-module--container--8V2pS";
export var attributionContent = "attributionPeter-module--attributionContent--6CTEJ";
export var attributionTitle = "attributionPeter-module--attributionTitle--iKHOL";
export var attributionSubtitle = "attributionPeter-module--attributionSubtitle--l9ebZ";
export var attributionImageContainer = "attributionPeter-module--attributionImageContainer--+5+Fr";
export var attributionImage = "attributionPeter-module--attributionImage--onkHt";
export var attributionImageButton = "attributionPeter-module--attributionImageButton--4BDBs";